import { Check, X } from "lucide-react";

const comparisonItems = [
  {
    feature: "Fully Insured",
    average: false,
    riekels: true,
  },
  {
    feature: "Consistent Weekly Schedule",
    average: false,
    riekels: true,
  },
  {
    feature: "Professional-Grade Equipment",
    average: false,
    riekels: true,
  },
  {
    feature: "Detailed Lawn Assessment",
    average: false,
    riekels: true,
  },
  {
    feature: "Seasonal Programs Available",
    average: false,
    riekels: true,
  },
  {
    feature: "Local Minnesota Company",
    average: false,
    riekels: true,
  },
  {
    feature: "Snow Removal Services",
    average: false,
    riekels: true,
  },
  {
    feature: "Landscape Design",
    average: false,
    riekels: true,
  },
  {
    feature: "Transparent Pricing",
    average: false,
    riekels: true,
  },
  {
    feature: "5-Star Google Reviews",
    average: false,
    riekels: true,
  },
];

export const ComparisonTable = () => {
  return (
    <section className="py-20 bg-section-alt">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <span className="section-badge">The Difference</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground mt-4 mb-4">
            Why Choose Riekels?
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            See how we stack up against the average lawn care company.
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-card rounded-2xl border border-border overflow-hidden shadow-lg">
            {/* Header */}
            <div className="grid grid-cols-3 bg-muted/50">
              <div className="p-4 md:p-6 font-heading font-bold text-foreground">
                Feature
              </div>
              <div className="p-4 md:p-6 text-center font-heading font-bold text-muted-foreground border-l border-border">
                Average Company
              </div>
              <div className="p-4 md:p-6 text-center font-heading font-bold text-secondary border-l border-border bg-secondary/5">
                Riekels
              </div>
            </div>

            {/* Rows */}
            {comparisonItems.map((item, index) => (
              <div
                key={index}
                className={`grid grid-cols-3 ${
                  index !== comparisonItems.length - 1 ? "border-b border-border" : ""
                }`}
              >
                <div className="p-4 md:p-5 text-foreground text-sm md:text-base">
                  {item.feature}
                </div>
                <div className="p-4 md:p-5 flex items-center justify-center border-l border-border">
                  {item.average ? (
                    <div className="w-8 h-8 rounded-full bg-green-100 flex items-center justify-center">
                      <Check className="w-5 h-5 text-green-600" />
                    </div>
                  ) : (
                    <div className="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center">
                      <X className="w-5 h-5 text-red-500" />
                    </div>
                  )}
                </div>
                <div className="p-4 md:p-5 flex items-center justify-center border-l border-border bg-secondary/5">
                  {item.riekels ? (
                    <div className="w-8 h-8 rounded-full bg-secondary/20 flex items-center justify-center">
                      <Check className="w-5 h-5 text-secondary" />
                    </div>
                  ) : (
                    <div className="w-8 h-8 rounded-full bg-red-100 flex items-center justify-center">
                      <X className="w-5 h-5 text-red-500" />
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
